import { Stethoscope, MessageCircle, Handshake } from 'lucide-react';

const SERVICE_ICON_MAP = {
  Stethoscope,
  MessageCircle,
  Handshake,
};

export const getServiceIcon = (iconName) => SERVICE_ICON_MAP[iconName] || Handshake;
